import React from 'react';
import i18next from 'i18next';
import { INFO_PANE_PAGES } from '../../redux_store/reducer/reducers/infoPaneReducer';

export const CHART_TYPES = {
  BAR: 'bar',
  PIE: 'pie',
  LINE: 'line',
};

export const CHARTS = [
  {
    key: 'ageRange',
    chartType: CHART_TYPES.PIE,
  },
  {
    key: 'generalHealth',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'allergicRhinitis',
    chartType: CHART_TYPES.LINE,
  },
  {
    key: 'asthma',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'allergicConjunctivitis',
    chartType: CHART_TYPES.PIE,
  },
  {
    key: 'allergicUrticara',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'symptomSeveritySnot22',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'physicalActivity',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'fruitVegetableConsumption',
    chartType: CHART_TYPES.BAR,
  },
  {
    key: 'tobaccoUse',
    chartType: CHART_TYPES.BAR,
  },
];

export const ASSESSMENTS_ALERTS_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'firstName',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'lastName',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:assessment'),
    accessorKey: 'surveyName',
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:completedTimestamp'),
    accessorKey: 'completedDate',
    disableSorting: true,
    isDefaultCell: true,
  },
];

export const ANIMATION_TIMEOUT = 1500;
